import type { statistics as en } from '@/i18n/locales/en/statistics';
import type { Translation } from '@/i18n/types';

export const statistics: Translation<typeof en> = {
  panelType: {
    series: 'Series',
    sessions: 'Sesiones',
    availability: 'Disponibilidad',
  },
  status: {
    forbidden: 'No tienes permiso para ver esto.',
    insufficientData:
      'Aún no hay suficientes personas con datos para mostrar este grupo sin identificar a nadie.',
    noMetrics: 'No hay métricas en este intervalo.',
    noData: 'No hay datos en este intervalo.',
    noSessions: 'No hay sesiones en este intervalo.',
    noAvailability: 'No se ha registrado ningún dato en absoluto.',
    loadFailed: 'No se pudo cargar este panel: {{message}}',
  },
  target: {
    you: 'Tú',
    department: 'Departamento {{name}}',
    company: 'Empresa {{name}}',
  },
  table: {
    date: 'Fecha',
    type: 'Tipo',
    duration: 'Duración',
    calories: 'Calorías',
    avgHeartRate: 'FC media',
    minutes: '{{count}} min',
    metric: 'Métrica',
    source: 'Origen',
    first: 'Primero',
    last: 'Último',
    days: 'Días',
  },
  detailLink: 'Ver detalles',
  range: {
    last7Days: 'Últimos 7 días',
    last30Days: 'Últimos 30 días',
    last90Days: 'Últimos 90 días',
    thisWeek: 'Esta semana',
    thisMonth: 'Este mes',
    custom: 'Personalizado…',
    from: 'Desde',
    to: 'Hasta',
  },
};
